//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import adminSection from '~/mixins/admin-section'
import GallerySlider from '~/components/section/selection/gallery_slider.vue'

export default {
  name: 'AdminSectionGallery',
  components: { GallerySlider },
  mixins: [adminSection],
  computed: {
    ...mapState({
      breakpoint: 'breakpoint'
    }),
    getSliderTitle () {
      return this.section?.title || this.pageData?.title || this.pageData?.data?.title
    },
    getSliderSettings: app => (name) => {
      const isSlider = true
      const SETTINGS = {
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  }
}
